import { render } from "./MatchDay.vue?vue&type=template&id=64acda57"
import script from "./MatchDay.vue?vue&type=script&lang=js"
export * from "./MatchDay.vue?vue&type=script&lang=js"

import "./MatchDay.vue?vue&type=style&index=0&id=64acda57&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__